import { Map } from 'immutable';
import ExportButtonGroup from 'portaltransparencia-common/components/ExportButtonGroup.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import Tab from 'portaltransparencia-common/components/Tab.react.js';
import Tabs from 'portaltransparencia-common/components/Tabs.react.js';
import configuration from 'portaltransparencia-common/config/Config.js';
import { onChange } from 'portaltransparencia-common/crud/Actions.js';
import StorageService from 'portaltransparencia-common/libs/StorageService.js';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Component from 'react-pure-render/component';
import { connect } from 'react-redux';

import PageHeader from '../components/PageHeader.react.js';
import NotasExplicativas from '../notaexplicativa/Form.react';
import UltimaAtualizacao from '../ultimaatualizacao/Form.react.js';
import * as actions from './Actions.js';
import RepasseListagem from './RepasseListagem.react.js';
import { addErrorNotification } from 'portaltransparencia-common/ui/Actions.js';
import RepassesRecebidosFiltro from './FormFiltro.react';

export class FormRepasse extends Component {
  static propTypes = {
    enviados: PropTypes.object.isRequired,
    recebidos: PropTypes.object.isRequired,
    filtros: PropTypes.object,
    findRepassesEnviados: PropTypes.func.isRequired,
    findRepassesRecebidos: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    addErrorNotification: PropTypes.func.isRequired
  };

  componentDidMount() {
    const { findRepassesEnviados, findRepassesRecebidos, match } = this.props;
    const { tipoRepasse } = match.params;

    const defaultQuery = 'mesInicial=01&mesFinal=12';

    if (tipoRepasse === 'receita') {
      findRepassesRecebidos(defaultQuery);
    } else {
      findRepassesEnviados(defaultQuery);
    }
  }

  onExporta = (exportType, openTab, windowParams) => {
    const { apiURL } = configuration;
    const { enviados, recebidos, addErrorNotification, match } = this.props;
    const { tipoRepasse } = match.params;

    const listaAtual = 
      tipoRepasse === 'receita' ? 
        {
          data: recebidos,
          type: 'R'
        } :
        {
          data: enviados,
          type: 'E'
        };

    if (listaAtual && listaAtual.data.size > 0) {
      const { entidade, exercicio } = StorageService.getItem('userInfo') || {};

      const filter =
        '&entidade=' +
        entidade.id +
        '&exercicio=' +
        exercicio.id +
        '&tipo=' +
        listaAtual.type +
        '&exportType=' +
        exportType;

      window.open(
        `${apiURL}/api/repasses/report?${filter}`,
        openTab,
        windowParams
      );
    } else {
      addErrorNotification(
        'A consulta não apresentou resultado. Não é possível exportar para o formato selecionado!'
      );
    }
  };

  renderFiltro() {
    const { tipoRepasse } = this.props.match.params;

    const tituloPainel = tipoRepasse === 'receita'
      ? 'Consultar em Repasses Recebidos'
      : 'Consultar em Repasses Enviados';

    return <RepassesRecebidosFiltro 
      key={`idRepasses_${tipoRepasse}_Filtro`} 
      titulo={tituloPainel} 
      tipoRepasse={tipoRepasse} 
    />;
  }

  render() {
    const { enviados, recebidos, filtros = Map({}), location, match } = this.props;
    const { exercicio } = StorageService.getItem('userInfo') || {};
    const { tipoRepasse } = match.params;

    const tipoRepasseInfo = 
      tipoRepasse === 'receita' ?
        {
          data: recebidos,
          tabName: 'recebidos',
          tabTitle: `Repasses Recebidos em ${exercicio?.id}`
        } :
        {
          data: enviados,
          tabName: 'enviados',
          tabTitle: `Repasses Enviados em ${exercicio?.id}`
        };

    return (
      <section>
        <PageHeader location={location} />

        <NotasExplicativas pathname={location.pathname} />

        {this.renderFiltro()}

        <Panel isForm expansible={false} tableResponsive>
          <Row>
            <Col xs={6}>
              <UltimaAtualizacao
                modulo="3"
                table="eloportalrepasses"
                column="dataultimaatualizacao"
              />
            </Col>
            <Col xs={6}>
              <ExportButtonGroup onClick={this.onExporta} visible={true} />
            </Col>
          </Row>

          <Tabs ref="tab">
            <Tab
              title={tipoRepasseInfo.tabTitle}
              name={tipoRepasseInfo.tabName}
              onlyTable
              active={true}
            >
              <RepasseListagem
                repasses={tipoRepasseInfo.data}
                tipoRepasse={tipoRepasse}
                mesInicial={filtros.get('mesInicial')}
                mesFinal={filtros.get('mesFinal')}
              />
            </Tab>
          </Tabs>
        </Panel>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    enviados: state.repasse.get('enviados'),
    recebidos: state.repasse.get('recebidos'),
    filtros: state.crud.getIn(['filtroRepasses', 'currentRecord'], Map({}))
  };
}

const allActions = {
  ...actions,
  onChange,
  addErrorNotification
};

export default connect(mapStateToProps, allActions)(FormRepasse);
